






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Container, Draggable } from 'vue-smooth-dnd';
import { applyDrag } from '@/utils/helpers';
@Component({
    components: {
        Container,
        Draggable
    }
})
export default class SortOncallMemberModal extends Vue {
    @Prop({ default: false })
    visible: boolean;
    @Prop({ default: 'user' })
    type: 'user' | 'group';
    @Prop({ default: () => [] })
    list: CommonTypes.mapObject;

    showModal: boolean = false;
    sortedList: CommonTypes.mapObject[] = [];

    @Watch('visible', { immediate: true })
    onVisibleChanged() {
        this.showModal = this.visible;
    }
    @Watch('list', { immediate: true })
    onDataChanged() {
        this.sortedList = [].concat(this.list);
    }
    onDropEvent(dropResult) {
        this.sortedList = applyDrag(this.sortedList, dropResult);
    }
    close() {
        this.$emit('update:visible', false);
    }
    confirm() {
        this.close();
        this.$emit('success', this.sortedList);
    }
}
